import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { LegalEntityListPageTabTypes } from './types'

const LegalEntityListFeatureSetChunk = lazy(() =>
  import('../feature-sets/LegalEntityListFeatureSet').then(
    ({ LegalEntityListFeatureSet }) => ({
      default: LegalEntityListFeatureSet,
    })
  )
)

export const LegalEntityListPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageEntitiesTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('LegalEntityListPage', {
            tab: LegalEntityListPageTabTypes.ACTIVE,
          }),
          name: intl.formatMessage(messages.manageEntitiesTitle),
        },
      ]}
    >
      <LegalEntityListFeatureSetChunk />
    </Page>
  )
}
